







































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DashboardPageSelectFilter, DashboardPageFilterType } from '@/models/hcad/shared/dashboard';
import { filterEditorComponents } from '@/utils/typed-configs';
import { validateRefs } from '@/utils/validate-refs';
import dashModule from '@/store/modules/DashboardModule';

@Component
export default class SelectConfigEdit extends Vue
{
    @Prop({type: Object, required: true})
    filter!: DashboardPageSelectFilter;
    
    keyOffset = 0;

    createOption()
    {
        this.filter.options.push('');
        ++this.keyOffset;
    }

    deleteOption(idx: number)
    {
        this.filter.options.splice(idx, 1);
        ++this.keyOffset;
    }

    swapOptions(a: number, b: number)
    {
        const bval = this.filter.options[b];
        this.filter.options[b] = this.filter.options[a];
        this.filter.options[a] = bval;
        ++this.keyOffset;
    }

    rules = {
        required: (value: string) => (!!value && value.trim().length > 0) || 'This field is required',
        url: () => true,
        requiredOrOther: (other: string | null) => (value: string)=>
        {
            if (!!other && other.trim().length > 0) return true;
            return (!!value && value.trim().length > 0) || 'This field is required';
        }
    };

    validate()
    {
        return validateRefs(this.$refs);
    }

    async populateOptionsFromBlade()
    {
        if (this.$route.params.targetId)
        {
            const values = await dashModule.getBladeDisplayValues({
                dashid: this.$route.params.targetId,
                type: this.filter.type,
            });
            if (values && values.length)
            {
                values.forEach((v) =>
                {
                    if (!(this.filter.options.includes(v))) 
                    {
                        this.filter.options.push(v);
                    }
                });
                this.filter.options.forEach((v, i) =>
                {
                    if (!(values.includes(v))) 
                    {
                        this.filter.options.splice(i, 1);
                    }
                });
                ++this.keyOffset;
            }
            else
            {
                alert('No options found.');
            }
        }
    }

    get isJob()
    {
        return this.filter.type === DashboardPageFilterType.JobCodeSelect;
    }

    get isDepartment()
    {
        return this.filter.type === DashboardPageFilterType.DepartmentSelect;
    }
}

filterEditorComponents
    .registerComponent(DashboardPageFilterType.LocationSelect, SelectConfigEdit)
    .registerDataFactory(DashboardPageFilterType.LocationSelect, ()=>new DashboardPageSelectFilter(DashboardPageFilterType.LocationSelect, [], 'Location'))
;
filterEditorComponents
    .registerComponent(DashboardPageFilterType.DepartmentSelect, SelectConfigEdit)
    .registerDataFactory(DashboardPageFilterType.DepartmentSelect, ()=>new DashboardPageSelectFilter(DashboardPageFilterType.DepartmentSelect, [], 'Department'))
;
filterEditorComponents
    .registerComponent(DashboardPageFilterType.FunctionSelect, SelectConfigEdit)
    .registerDataFactory(DashboardPageFilterType.FunctionSelect, ()=>new DashboardPageSelectFilter(DashboardPageFilterType.FunctionSelect, [], 'Function'))
;
filterEditorComponents
    .registerComponent(DashboardPageFilterType.JobCodeSelect, SelectConfigEdit)
    .registerDataFactory(DashboardPageFilterType.JobCodeSelect, ()=>new DashboardPageSelectFilter(DashboardPageFilterType.JobCodeSelect, [], 'Job Code'))
;
filterEditorComponents
    .registerComponent(DashboardPageFilterType.CompanySelect, SelectConfigEdit)
    .registerDataFactory(DashboardPageFilterType.CompanySelect, ()=>new DashboardPageSelectFilter(DashboardPageFilterType.CompanySelect, [], 'Company'))
;
